import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axios_helper/axiosInstance';
import '../style/login.css'; 
import logo from '../images/mahaveer-je-logo.png';
import CircularProgress from '@mui/material/CircularProgress';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(true); // Loading state for page load
  const [loggingIn, setLoggingIn] = useState(false); // Loading state for login
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate loading for 2 seconds when the component mounts
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoggingIn(true); // Set loading state to true for login

    // Simulate a delay for 2 seconds
    setTimeout(async () => {
      try {
        const response = await axiosInstance.post('login/', { username, password });
        localStorage.setItem('token', response.data.token);
        navigate('/dashboard');
      } catch (error) {
        console.error('Login failed:', error);
        alert('Login failed. Please check your username and password.');
      } finally {
        setLoggingIn(false); // Reset loading state after login attempt
      }
    }, 2000);
  };

  if (loading) {
    // Render loader while loading
    return (
      <div className="widget-loader">
        <CircularProgress size={40} style={{ color: "#7451f8" }} />
      </div>
    );
  }

  if (loggingIn) {
    // Render loader during login process
    return (
      <div className="widget-loader">
        <CircularProgress size={40} style={{ color: "#7451f8" }} />
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="img">
        <img src={logo} alt="" />
        <h2>Mahaveer Jewellers</h2>
      </div>
      <form className='form-group' onSubmit={handleLogin}>
        <div className='user_input'>
          <label>Username:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className='pass_input'>
          <label>Password:</label>
          <input
            type="password"
            autocomplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className='login_btn' type="submit">Login</button>
      </form>
    </div>
  );
}
